import { render } from "./attachment-form.vue?vue&type=template&id=3cd5074a&scoped=true&ts=true"
import script from "./attachment-form.vue?vue&type=script&lang=ts"
export * from "./attachment-form.vue?vue&type=script&lang=ts"

import "./attachment-form.vue?vue&type=style&index=0&id=3cd5074a&lang=scss"
import "./attachment-form.vue?vue&type=style&index=1&id=3cd5074a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Fattachment-form%2Fattachment-form.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd5074a"]])

export default __exports__